import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'domorelife-web',
    },
  },
});

// Dev login credentials for one-click testing
export const DEV_USERS = {
  host: {
    email: 'cafe@example.com',
    password: 'pass123',
    userType: 'host',
    displayName: 'Café Host',
  },
  user: {
    email: 'alice@example.com',
    password: 'pass123',
    userType: 'user',
    displayName: 'Regular User',
  },
  admin: {
    email: 'admin@austin.com',
    password: 'pass123',
    userType: 'admin',
    displayName: 'Admin User',
  },
};
